export const LOAD_QVCT_ANSWER_CHOICE = 'LOAD_QVCT_ANSWER_CHOICE'